import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TicketSource } from '@sb-tools/typescript/enums/ticket-source.enum';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'ticketSource',
})
export class TicketSourcePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(ticketSource: TicketSource): string {
        if (typeof ticketSource === 'string') {
            ticketSource = +ticketSource;
        }

        switch (ticketSource) {
            case TicketSource.all:
                return this.translateService.instant('All');
            case TicketSource.form:
                return this.translateService.instant('Form');
            case TicketSource.facebook:
                return this.translateService.instant('Facebook');
            case TicketSource.instagram:
                return this.translateService.instant('Instagram');
            case TicketSource.email:
                return this.translateService.instant('Email');
            case TicketSource.chat:
                return this.translateService.instant('Chat');
            case TicketSource.youtube:
                return this.translateService.instant('YouTube');
            case TicketSource.googleMyBusiness:
                return this.translateService.instant('Google My Business');
            case TicketSource.trustpilot:
                return this.translateService.instant('Trustpilot');
            case TicketSource.googlePlayMarket:
                return this.translateService.instant('Google Play Market');
            case TicketSource.appStore:
                return this.translateService.instant('App Store');
            case TicketSource.whatsApp:
                return this.translateService.instant('WhatsApp');
            case TicketSource.tikTok:
                return this.translateService.instant('TikTok');
            case TicketSource.api:
                return this.translateService.instant('API');
            default:
                return this.translateService.instant('Unknown source');
        }
    }
}
